var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDownOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3328 2.66667L8.82609 2.04C8.72035 2.0135 8.61177 2.00007 8.50276 2H5.82409C5.57643 2.00001 5.33366 2.069 5.12301 2.19923C4.91235 2.32946 4.74213 2.51579 4.63143 2.73733L2.29809 7.404C2.19651 7.60728 2.14858 7.83315 2.15883 8.06016C2.16908 8.28717 2.23719 8.5078 2.35667 8.70109C2.47616 8.89438 2.64307 9.05393 2.84156 9.16458C3.04004 9.27524 3.26351 9.33333 3.49076 9.33333H6.66676H8.00009M11.3328 2.66667L11.3334 8.66667L9.07209 12.0587C8.80742 12.4553 8.66676 12.9207 8.66676 13.3973C8.66676 13.73 8.39676 14 8.06343 14H7.99942C7.6458 14 7.30666 13.8595 7.05662 13.6095C6.80657 13.3594 6.66609 13.0203 6.66609 12.6667V9.33333M11.3328 2.66667H12.6668C13.0204 2.66667 13.3595 2.80714 13.6096 3.05719C13.8596 3.30724 14.0001 3.64638 14.0001 4V8C14.0001 8.35362 13.8596 8.69276 13.6096 8.94281C13.3595 9.19286 13.0204 9.33333 12.6668 9.33333H11.0001",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownOutline);
export default __webpack_public_path__ + "static/media/ThumbDownOutline.c608f1c0a8383178a34eced0e4438389.svg";
export { ForwardRef as ReactComponent };